import { all, put, take } from 'redux-saga/effects';
import { AuthenticationActions, AuthenticationTypes } from '../store/authentication';
import { createAsyncSaga } from '../cores/createAsyncSaga';
import { PayloadAction } from 'typesafe-actions';
import { AxiosResponse } from 'axios';
import { ToastActions, ToastMessageTypes } from '../store/toast';
import { getLocalStorageToken } from '../cores/getLocalStorageToken';

export default function*() {
  yield all([...createAsyncSaga(AuthenticationActions), getToken(), watchSetLogin()]);
}

export const tokenName = `token`;
export const refreshTokenName = `refreshToken`;

function* getToken() {
  const token = getLocalStorageToken();
}

function* watchSetLogin() {
  while (true) {
    const {
      payload: { data }
    }: PayloadAction<
      typeof AuthenticationTypes.setLogin,
      AxiosResponse<{ token: string; refresh_token: string; user: { is_staff: boolean } }>
    > = yield take(AuthenticationActions.setLogin.success);

    const { token, refresh_token } = data;
    if (token) {
      setLocalStorageToken(token);
      setLocalStorageRefreshToken(refresh_token);
      yield put(AuthenticationActions.setToken(token));
      yield put(
        ToastActions.createToast({
          type: ToastMessageTypes.Success,
          message: '로그인 되었습니다.'
        })
      );
    }
  }
}

export function setLocalStorageToken(token = '') {
  localStorage.setItem(tokenName, token);
}

export function setLocalStorageRefreshToken(refreshToken = '') {
  localStorage.setItem(refreshTokenName, refreshToken);
}

export function getLocalStorageRefreshToken() {
  return localStorage.getItem(refreshTokenName);
}
